import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import * as i0 from '@angular/core';
import { inject, Injectable, NgModule } from '@angular/core';
import * as i2 from '@spartacus/core';
import { LoggerService, normalizeHttpError, InterceptorUtil, USE_CLIENT_TOKEN, provideDefaultConfig } from '@spartacus/core';
import { USER_ACCOUNT_NORMALIZER, LOGIN_FORM_SERIALIZER, VERIFICATION_TOKEN_NORMALIZER, UserAccountAdapter } from '@spartacus/user/account/core';
import { catchError } from 'rxjs/operators';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const defaultOccUserAccountConfig = {
  backend: {
    occ: {
      endpoints: {
        user: 'users/${userId}',
        createVerificationToken: 'users/anonymous/verificationToken'
      }
    }
  }
};

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
const CONTENT_TYPE_JSON_HEADER = {
  'Content-Type': 'application/json'
};
class OccUserAccountAdapter {
  constructor(http, occEndpoints, converter) {
    this.http = http;
    this.occEndpoints = occEndpoints;
    this.converter = converter;
    this.logger = inject(LoggerService);
  }
  load(userId) {
    const url = this.occEndpoints.buildUrl('user', {
      urlParams: {
        userId
      }
    });
    return this.http.get(url).pipe(catchError(error => {
      throw normalizeHttpError(error, this.logger);
    }), this.converter.pipeable(USER_ACCOUNT_NORMALIZER));
  }
  createVerificationToken(verificationTokenCreation) {
    const url = this.occEndpoints.buildUrl('createVerificationToken');
    const headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, new HttpHeaders({
      ...CONTENT_TYPE_JSON_HEADER
    }));
    verificationTokenCreation = this.converter.convert(verificationTokenCreation, LOGIN_FORM_SERIALIZER);
    return this.http.post(url, verificationTokenCreation, {
      headers
    }).pipe(catchError(error => {
      throw normalizeHttpError(error, this.logger);
    }), this.converter.pipeable(VERIFICATION_TOKEN_NORMALIZER));
  }
  static {
    this.ɵfac = function OccUserAccountAdapter_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OccUserAccountAdapter)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.OccEndpointsService), i0.ɵɵinject(i2.ConverterService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OccUserAccountAdapter,
      factory: OccUserAccountAdapter.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OccUserAccountAdapter, [{
    type: Injectable
  }], () => [{
    type: i1.HttpClient
  }, {
    type: i2.OccEndpointsService
  }, {
    type: i2.ConverterService
  }], null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
class UserAccountOccModule {
  static {
    this.ɵfac = function UserAccountOccModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UserAccountOccModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: UserAccountOccModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [provideDefaultConfig(defaultOccUserAccountConfig), {
        provide: UserAccountAdapter,
        useClass: OccUserAccountAdapter
      }]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UserAccountOccModule, [{
    type: NgModule,
    args: [{
      providers: [provideDefaultConfig(defaultOccUserAccountConfig), {
        provide: UserAccountAdapter,
        useClass: OccUserAccountAdapter
      }]
    }]
  }], null, null);
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { OccUserAccountAdapter, UserAccountOccModule, defaultOccUserAccountConfig };
